module.exports = __webpack_public_path__ + "img/guide_gps.96cdc08f.png";